<template>
  <div class="animated fadeIn col-md-12">
    <b-modal
      size="lg"
      no-close-on-backdrop
      title
      v-model="formModal"
      hide-footer
      hide-header
    >
      <b-row>
        <b-col cols="12">
          <b-card>
            <div slot="header">{{ $lang.assessment_plan_data }}</div>
            <div v-show="errors.length" class="alert-danger" dismissible>
              <h4>خطا:</h4>
              <ul v-bind:key="index" v-for="(error, index) in errors">
                <li>{{ error }}</li>
              </ul>
            </div>
            <div class="text-center" v-show="isLoading">
              <b-spinner variant="primary" label="Text Centered"></b-spinner>
            </div>
            <b-form @submit.prevent="save" v-show="!isLoading">
              <b-form-group
                label="زمان"
                label-for="time"
                :label-cols="this.$config.form.labelCol"
              >
                <requiredComponent
                  slot="label"
                  label="زمان شروع"
                  :rules="$v.time.$params"
                />
                <date-picker
                  v-model="$v.time.$model"
                  :state="$v.time.$dirty ? !$v.time.$error : null"
                  format="HH:mm"
                  display-format="HH:mm"
                  :min="start_time"
                  :max="end_time"
                  type="time"
                  inputReq="true"
                  :roundMinute="true"
                  :class="
                    $v.time.$dirty
                      ? $v.time.$error
                        ? 'invalid-date'
                        : 'valid-date'
                      : null
                  "
                ></date-picker>

                <b-form-invalid-feedback id="category_id-feedback"
                  >دسته بندی ضروری است</b-form-invalid-feedback
                >
              </b-form-group>

              <b-form-group>
                <template v-slot:label>
                  <requiredComponent
                    slot="label"
                    label="شرکت کننده"
                    :rules="$v.candidate_selected.$params"
                  />

                  <b-form-checkbox
                    v-if="mode == 'insert'"
                    v-model="allSelected"
                    :indeterminate="indeterminate"
                    aria-describedby="flavours"
                    aria-controls="flavours"
                    @change="toggleAll"
                  >
                    {{
                      allcandidate_selected
                        ? $lang.UnSelectAll
                        : $lang.selectAll
                    }}</b-form-checkbox
                  >
                </template>

                <template v-if="mode == 'insert'">
                  <b-form-checkbox-group
                    id="flavors"
                    v-model="$v.candidate_selected.$model"
                    :options="candidate_options_checkbox"
                    name="flavors"
                    aria-label="Individual flavours"
                    inline
                  >
                  </b-form-checkbox-group>
                </template>
                <template v-if="mode == 'edit'">
                  <b-form-checkbox
                    v-for="option in candidate_options_checkbox"
                    v-model="$v.candidate_single_selected.$model"
                    :key="option"
                    :value="option"
                    name="candidate_options_options"
                    inline
                    >{{ option }}</b-form-checkbox
                  >
                </template>
                <b-form-invalid-feedback
                  :state="
                    $v.candidate_selected.$dirty
                      ? !$v.candidate_selected.$error
                      : null
                  "
                >
                  <div v-if="!$v.candidate_selected.required">
                    {{ $lang.error_required | replace($lang.candidate) }}
                  </div>
                </b-form-invalid-feedback>
              </b-form-group>
              <b-form-group
                :label="$lang.assessment_plan_type"
                label-for="is_enable"
                :label-cols="12"
              >
                <b-form-radio-group
                  id="is_enable"
                  :autocomplete="$lang.assessment_plan_type"
                  v-model="$v.is_enable.$model"
                  :state="$v.is_enable.$dirty ? !$v.is_enable.$error : null"
                  :options="is_enable_options"
                  buttons
                  button-variant="outline-primary"
                  size="md"
                  name="radio-btn-outline"
                  @change="changeAssessmentPlanType"
                />
              </b-form-group>

              <b-form-group
                v-if="is_enable === 1"
                label="تمرین"
                label-for="category_id"
                :label-cols="this.$config.form.labelCol"
                class="multiselect-form"
              >
                <requiredComponent
                  slot="label"
                  label="تمرین"
                  :rules="$v.exercise_algorithm_selected.$params"
                />

                <selectAsync
                  @input="changeDuration"
                  :options="exercise_algorithm_options"
                  v-model="$v.exercise_algorithm_selected.$model"
                  label="text"
                  id="value"
                  :isValid="
                    $v.exercise_algorithm_selected.$dirty
                      ? !$v.exercise_algorithm_selected.$error
                      : null
                  "
                  :asyncFind="getTemplateExerciseOptions"
                  :loading="exerciseAlgorithmDetailLoading"
                />

                <b-form-invalid-feedback id="category_id-feedback"
                  >دسته بندی ضروری است</b-form-invalid-feedback
                >
              </b-form-group>

              <b-form-group
                v-if="is_enable === 2"
                :label="$lang.exam_pack"
                label-for="category_id"
                :label-cols="this.$config.form.labelCol"
                class="multiselect-form"
              >
                <requiredComponent
                  slot="label"
                  :label="$lang.exam_pack"
                  :rules="$v.exam_pack_selected.$params"
                />

                <selectAsync
                  @input="changeDuration"
                  :options="exam_pack_options"
                  v-model="$v.exam_pack_selected.$model"
                  label="text"
                  id="value"
                  :isValid="
                    $v.exam_pack_selected.$dirty
                      ? !$v.exam_pack_selected.$error
                      : null
                  "
                  :asyncFind="getExamPackOptions"
                  :loading="exam_pack_loading"
                />

                <b-form-invalid-feedback id="category_id-feedback"
                  >دسته بندی ضروری است</b-form-invalid-feedback
                >
              </b-form-group>
              <b-form-group
                :label="$lang.run_duration"
                label-for="category_id"
                :label-cols="this.$config.form.labelCol"
                class="multiselect-form"
              >
                <requiredComponent
                  slot="label"
                  :label="$lang.run_duration"
                  :rules="$v.runtime_duration.$params"
                />

                <b-form-input
                  id="run_duration"
                  type="number"
                  min="5"
                  max="600"
                  step="5"
                  :autocomplete="$lang.runtime_duration"
                  v-model="$v.runtime_duration.$model"
                  :state="
                    $v.runtime_duration.$dirty
                      ? !$v.runtime_duration.$error
                      : null
                  "
                ></b-form-input>
                <small class="form-text text-muted w-100 text-right">{{
                  $lang.minute
                }}</small>

                <b-form-invalid-feedback
                  id="run_duration-feedback"
                  v-if="!$v.runtime_duration.required"
                >
                  {{
                    $lang.error_required | replace($lang.runtime_duration)
                  }}</b-form-invalid-feedback
                >

                <div
                  class="invalid-feedback"
                  v-if="
                    $v.runtime_duration.required &&
                    !$v.runtime_duration.minValue
                  "
                >
                  {{
                    $lang.error_min_value | replace($lang.runtime_duration, 1)
                  }}
                </div>
              </b-form-group>

              <b-form-group
                :label="$lang.delay_for_send"
                label-for="delay_for_send"
                :label-cols="this.$config.form.labelCol"
                class="multiselect-form"
              >
                <requiredComponent
                  slot="label"
                  :label="$lang.delay_for_send"
                  :rules="$v.delay_for_send.$params"
                  :showInfo="true"
                  :titleText="$lang.delay_for_send_info"
                />

                <b-form-input
                  id="delay_for_send"
                  type="number"
                  min="5"
                  max="600"
                  step="5"
                  autocomplete="off"
                  v-model="$v.delay_for_send.$model"
                  :state="
                    $v.delay_for_send.$dirty ? !$v.delay_for_send.$error : null
                  "
                ></b-form-input>
                <small class="form-text text-muted w-100 text-right">{{
                  $lang.minute
                }}</small>

                <b-form-invalid-feedback
                  id="delay_for_send-feedback"
                  v-if="!$v.delay_for_send.required"
                >
                  {{
                    $lang.error_required | replace($lang.delay_for_send)
                  }}</b-form-invalid-feedback
                >

                <div
                  class="invalid-feedback"
                  v-if="
                    $v.delay_for_send.required && !$v.delay_for_send.minValue
                  "
                >
                  {{ $lang.error_min_value | replace($lang.delay_for_send, 1) }}
                </div>
              </b-form-group>

              <b-form-group
                label="ارزیاب"
                label-for="assessor_selected"
                :label-cols="this.$config.form.labelCol"
              >
                <b-row>
                  <b-col cols="12">
                    <requiredComponent
                      slot="label"
                      :rules="$v.assessor_selected.$params"
                    />
                    <b-form-checkbox
                      v-for="option in assessor_options"
                      v-model="$v.assessor_selected.$model"
                      :key="option"
                      :value="option"
                      name="assessor_options"
                      inline
                      >{{ option }}
                    </b-form-checkbox>
                  </b-col>
                </b-row>
              </b-form-group>

              <b-form-group
                label="اتاق"
                label-for="room_selected"
                :label-cols="this.$config.form.labelCol"
              >
                <b-row>
                  <b-col cols="12">
                    <requiredComponent
                      slot="label"
                      :rules="$v.room_selected.$params"
                    />
                    <b-form-checkbox
                      v-for="option in room_options"
                      v-model="$v.room_selected.$model"
                      :key="option.value"
                      :value="option.value"
                      name="room_options"
                      inline
                      >{{ option.text }}
                    </b-form-checkbox>
                  </b-col>
                </b-row>
              </b-form-group>

              <div
                slot="footer"
                class="form-group form-btn"
                v-show="!isLoading"
              >
                <b-button
                  type="submit"
                  size="md"
                  variant="success"
                  class="mr-2"
                  v-if="mode == 'insert'"
                >
                  {{ $lang.submitButton }}
                  <i class="fa fa-check"></i>
                </b-button>
                <b-button
                  size="md"
                  variant="success"
                  @click="editPlan"
                  class="mr-2"
                  v-if="mode == 'edit'"
                >
                  {{ $lang.edit }}
                  <i class="fa fa-check"></i>
                </b-button>
                <b-button
                  size="md"
                  variant="danger"
                  @click="removePlan"
                  class="mr-2"
                  v-if="mode == 'edit'"
                >
                  {{ $lang.remove }}
                  <i class="fa fa-ban"></i>
                </b-button>
                <b-button size="md" variant="warning" @click="cancelPlan()">
                  {{ $lang.cancelButton }}
                  <i class="fas fa-dot-circle"></i>
                </b-button>
              </div>
            </b-form>
          </b-card>
        </b-col>
      </b-row>
    </b-modal>
    <b-row>
      <b-col>
        <b-card bg-variant="light" header="Light" class="text-left">
          <div slot="header">
            <div class="d-flex float-left">
              <b-form-group
                :label="`${$lang.selectedZoom}: `"
                label-for="selectedZoom"
                label-cols="auto"
                class="mb-0"
              >
                <b-input-group append="دقیقه">
                  <b-form-input
                    class="w-auto"
                    type="number"
                    v-model="selectedZoom"
                    @input="delaySearch"
                    :min="duration"
                    max="60"
                    :step="time_step"
                  />
                </b-input-group>
              </b-form-group>
            </div>
            <div class="d-flex float-right">
              <div v-if="day_options.length" class="mr-1">
                <requiredComponent
                  slot="label"
                  :rules="$v.day_selected.$params"
                />
                <selectFind
                  :options="day_options"
                  v-model="$v.day_selected.$model"
                  label="text"
                  id="category_id"
                  :isValid="
                    $v.day_selected.$dirty ? !$v.day_selected.$error : null
                  "
                />
                <b-form-invalid-feedback id="category_id-feedback"
                  >دسته بندی ضروری است</b-form-invalid-feedback
                >
              </div>
              <b-button-group size="md" class="ml-1">
                <b-button
                  variant="success"
                  active
                  @click="viewMode = 'total'"
                  v-text="$lang.total"
                />
                <b-button
                  variant="info"
                  @click="viewMode = 'exercise'"
                  v-text="$lang.exercise_exam_pack"
                />
                <b-button
                  variant="warning"
                  @click="viewMode = 'assessor'"
                  v-text="$lang.assessor"
                />
                <b-button
                  variant="secondary"
                  @click="viewMode = 'room'"
                  v-text="$lang.room"
                />
              </b-button-group>

              <b-button
                variant="primary"
                v-b-tooltip.hover
                :title="$lang.new_data"
                class="ml-3"
                @click="addPlan"
              >
                <i class="fa fa-plus" />
              </b-button>
            </div>
          </div>
          <div class="content-wrapper">
            <div
              id="skeduler-container"
              :class="items.length ? 'skeduler-container' : ''"
            >
              <div class="skeduler-headers">
                <div
                  class="d-flex align-items-center justify-content-center"
                  :style="`${widthStyle()}`"
                  v-for="(item, index) in items"
                  :key="index"
                >
                  <div class="media">
                    <div class="media-body">
                      <h4 :class="`media-heading `" :id="index">
                        {{ item.name }}
                      </h4>
                    </div>
                  </div>
                </div>
              </div>
              <div class="skeduler-main">
                <div class="skeduler-main-timeline">
                  <template v-for="(time, index) in timeGrid">
                    <div
                      class="timeline"
                      :id="`timeline-` + index"
                      :key="index"
                    >
                      {{ time }}
                    </div>
                  </template>
                </div>
                <div
                  :class="`skeduler-main-body`"
                  :style="`${widthStyle()}`"
                  :id="itemBody.name"
                  v-for="(itemBody, timingIndex) in items"
                  :key="timingIndex.id"
                >
                  <div class="w-100" v-if="items">
                    <div
                      class="skeduler-task-placeholder"
                      v-for="(item, eventIndex) in itemBody.event"
                      :key="eventIndex"
                    >
                      <div
                        class="text-width"
                        :style="styleEvent(item)"
                        :title="titleText(item)"
                        @dragstart="dragStart"
                        @drag="dragging($event, item)"
                        draggable="true"
                        :id="`dragtarget-` + timingIndex + `-` + eventIndex"
                        @click="selectPlan(item)"
                      >
                        <div :class="selectedZoom > 30 ? `white-space` : ``">
                          <span
                            v-if="
                              item.type &&
                              (item.type.resource == `exercise_algorithm` ||
                                item.type.resource == `exam_pack`) &&
                              (viewMode == 'total' || viewMode == 'exercise')
                            "
                            >{{ item.type && item.type.caption }}</span
                          >
                          <span
                            v-if="
                              item.assessor &&
                              (viewMode == 'total' || viewMode == 'assessor')
                            "
                            >- {{ $lang.assessor }}: {{ item.assessor }}</span
                          >
                          <span
                            v-if="
                              item.room &&
                              (viewMode == 'total' || viewMode == 'room')
                            "
                            >-{{ $lang.room }}: {{ item.room }}</span
                          >
                        </div>
                      </div>
                    </div>
                    <div
                      :class="`skeduler-cell w-100`"
                      v-for="(item, index) in countGrid"
                      :key="item + (index + 2 / 3)"
                      @drop="drop"
                      @dragover="allowDrop"
                      @dragenter="dragEnter"
                      @dragleave="dragLeave"
                      :id="itemBody.name + '.' + index"
                      @click="addPlan($event, itemBody.name, index)"
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="text-center" v-show="assessment_plan_dataLoading">
            <b-spinner variant="primary" label="Text Centered"></b-spinner>
          </div>
          <div
            v-if="items.length == 0 && !assessment_plan_dataLoading"
            class="text-center"
          >
            <h5>{{ $lang.fill_edit_assesment_paln }}</h5>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import {
  required,
  minValue,
  numeric,
  requiredIf,
} from "vuelidate/lib/validators";
import { pathOr } from "ramda";
import { generateApiUrl, generateError } from "@/shared/utils";
import { getTemplateExerciseCombo } from "@/services";
import { getExamPackCombo } from "@/services/combo-services";

export default {
  name: "assessment-plan-pseudo-data",
  components: {
    datePicker: VuePersianDatetimePicker,
  },
  validations: {
    exercise_algorithm_selected: {
      required: requiredIf((vm) => vm.is_enable === 1),
    }, // add required
    assessor_options: {},
    assessor_selected: {},
    candidate_selected: { required },
    room_selected: {},
    time: { required },
    is_enable: {},
    day_selected: {},
    candidate_single_selected: {},
    exam_pack_selected: { required: requiredIf((vm) => vm.is_enable === 2) }, // add required
    runtime_duration: {
      required,
      minValue: minValue(1),
      numeric,
    },
    delay_for_send: {
      minValue: minValue(1),
      numeric,
    },
  },
  props: {
    isModal: {
      type: Boolean,
      default: false,
    },
    backUrl: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      currentTemplateId: null,
      exam_pack_loading: false,
      exam_pack_selected: null,
      exam_pack_options: [],
      allSelected: false,
      indeterminate: false,
      center_execute_type: null,
      id: this.$route.params.id,
      showContext: false,
      mode: "insert",
      title: "",
      isLoading: false,
      exerciseAlgorithmDetailLoading: false,
      errors: [],
      exercise_algorithm_options: [],
      candidate_number: [],
      candidate_options_checkbox: [],
      assessor_options: [],
      room_options: [],
      assessorLoading: false,
      assessor_selected: null,
      room_selected: null,
      candidate_selected: [],
      exercise_algorithm_selected: null,
      items: [],
      countGrid: [],
      fields: [],
      timeGrid: [],
      configCandidate: 21,
      configAssessor: 10,
      time: "",
      plans: [],
      day_options: [],
      day_selected: null,
      assessment_plan_dataLoading: false,
      assessment_plan_data: [],
      start_time: "",
      end_time: "",
      colorsObject: {},
      viewMode: "total",
      selected_plan_id: null,
      formModal: false,
      edit_assessor_selected: null,
      edit_room_selected: null,
      edit_candidate_selected: null,
      edit_exercise_algorithm_selected: null,
      edit_time: null,
      editLoading: false,
      edit_day_selected: null,
      duration: "",
      time_step: null,
      selectedZoom: null,
      itemGragging: null,
      is_enable: 1,
      optionsZoom: [
        {
          value: 5,
          text: 5,
        },
        {
          value: 10,
          text: 10,
        },
        {
          value: 15,
          text: 15,
        },
        {
          value: 60,
          text: 60,
        },
      ],
      selected_item: {},
      candidate_single_selected: null,
      runtime_duration: null,
      delay_for_send: null,
      readonly: false,
      debounceGet: null,
    };
  },
  computed: {
    is_enable_options() {
      return [
        {
          value: 1,
          text: this.$lang.exercise,
        },
        {
          value: 2,
          text: this.$lang.exam_pack,
        },
      ];
    },
  },
  created() {
    this.fetchData();
  },
  watch: {
    allcandidate_selected(newVal) {
      if (newVal) {
        this.candidate_selected = this.candidate_number;
      }
    },
    candidate_selected(newVal, oldVal) {
      // Handle changes in individual flavour checkboxes
      if (!newVal) return;

      if (newVal.length === 0) {
        this.indeterminate = false;
        this.allcandidate_selected = false;
      } else if (newVal.length === this.candidate_number.length) {
        this.indeterminate = false;
        this.allcandidate_selected = true;
      } else {
        this.indeterminate = true;
        this.allcandidate_selected = false;
      }
    },
  },
  methods: {
    pathOr,
    generateApiUrl,
    async getTemplateExerciseOptions(text = null) {
      try {
        this.exerciseAlgorithmDetailLoading = true;
        const response = await getTemplateExerciseCombo(
          this.currentTemplateId,
          text
        );
        const { options } = response;
        this.exercise_algorithm_options = options;
      } catch (error) {
        generateError(error);
      } finally {
        this.exerciseAlgorithmDetailLoading = false;
      }
    },
    async getExamPackOptions(text = null) {
      try {
        this.exam_pack_loading = true;
        const response = await getExamPackCombo(text);
        const { options } = response;
        this.exam_pack_options = options;
      } catch (error) {
        generateError(error);
      } finally {
        this.exam_pack_loading = false;
      }
    },
    changeAssessmentPlanType() {
      this.runtime_duration = "";
    },
    changeDuration(item) {
      this.runtime_duration = item.duration;
    },
    changeZoom() {
      if (this.selectedZoom >= 5 && this.selectedZoom <= 60) {
        this.getAssessment_plan();
      } else {
        this.$notify.error("فاصله زمانی باید بین 5 تا 60 دقیقه باشد");
      }
    },
    delaySearch() {
      if (this.debounceGet) {
        clearTimeout(this.debounceGet);
        this.debounceGet = null;
      }
      this.debounceGet = setTimeout(() => {
        this.changeZoom();
      }, 800);
    },
    toggleAll(checked) {
      this.candidate_selected = checked
        ? this.candidate_options_checkbox.slice()
        : [];
    },
    addPlan(event, candidate = null, time = null) {
      this.assessor_selected = null;
      this.exercise_algorithm_selected = null;
      this.delay_for_send = null;

      this.candidate_selected = candidate ? [candidate] : [];

      if (time) {
        let id = event.target.id.split(".");
        let el = document.getElementById(`timeline-${id[1]}`);
        this.time = el ? el.innerHTML : null;
      } else {
        this.time = this.start_time;
      }
      this.room_selected = null;
      this.runtime_duration = null;
      this.selected_plan = null;
      this.selected_plan_id = null;
      this.formModal = true;
      this.mode = "insert";
      this.getTemplateExerciseOptions();
      this.getExamPackOptions();
    },
    showContextMenu(item, e) {
      if (!this.isEmptyPlan(item)) {
        e.preventDefault();
        this.showContext = true;
        this.$refs.contextMenu;
        var menu = document.getElementById("context-menu");

        menu.style.left = e.pageX + "px";
        menu.style.top = e.pageY + "px";
        menu.style.display = "block";
        menu.cid = e.target.id.replace(/title-/, "");
      }
    },
    afterSave() {
      this.clear();
      this.formModal = false;
      this.isLoading = false;
      this.getAssessment_plan_data();
    },
    cancelPlan() {
      this.selected_item = {};
      this.formModal = false;
      this.clear();
    },
    async removePlan() {
      if (!this.selected_plan_id) return;
      try {
        this.isLoading = true;
        this.errors = [];
        const url = generateApiUrl(
          ["kanoon", "assessment_plan_pseudo_data_id"],
          [this.id, this.selected_plan_id]
        );
        const response = await this.$httpService.delete(url);
        this.$notify.success(response.data.message);
        this.afterSave();
      } catch (error) {
        const status = pathOr(null, ["response", "status"], error);
        const message = pathOr(null, ["response", "data", "message"], error);
        const con = status === 400 && Array.isArray(message);
        if (con) {
          this.errors = [...message];
        } else {
          this.generateError(error);
        }
      } finally {
        this.isLoading = false;
      }
    },
    editPlan() {
      this.isLoading = true;
      this.errors = [];

      let start = new Date();
      start.setHours(this.start_time.split(":")[0]);
      start.setMinutes(this.start_time.split(":")[1]);

      const end = new Date();
      end.setHours(this.time.split(":")[0]);

      end.setMinutes(this.time.split(":")[1]);

      const diffMs = end - start;
      const diffMins = Math.round(diffMs / 60000);
      const payload = {
        candidate_number: this.candidate_single_selected,
        assessor_number: this.assessor_selected ? this.assessor_selected : null,
        room_number: this.room_selected ? this.room_selected : null,
        day_number: pathOr(this.day_options[0], ["value"], this.day_selected),
        delay_from_start: diffMins,
        duration: this.runtime_duration,
        delay_for_send: this.delay_for_send,
      };
      if (this.is_enable == 1) {
        payload["resource"] = "exercise_algorithm";
        payload["resource_id"] = pathOr(
          null,
          ["value"],
          this.exercise_algorithm_selected
        );
      }

      if (this.is_enable == 2) {
        payload["resource"] = "exam_pack";
        payload["resource_id"] = pathOr(
          null,
          ["value"],
          this.exam_pack_selected
        );
      }
      this.updateAssessmentPlan("editForm", payload);
    },
    dropEdit(time, candidateNumber) {
      let start = new Date();
      start.setHours(this.start_time.split(":")[0]);
      start.setMinutes(this.start_time.split(":")[1]);

      let end = new Date();

      end.setHours(time.split(":")[0]);
      end.setMinutes(time.split(":")[1]);

      let diffMs = end - start;
      let diffMins = Math.round(diffMs / 60000);
      let payload = {
        candidate_number: candidateNumber ? parseInt(candidateNumber) : null,
        day_number: this.itemGragging.day_number
          ? this.itemGragging.day_number
          : null,
        delay_from_start: diffMins,
        duration: this.itemGragging.duration,
      };
      return this.patchAssessmentPlan(event, payload)
        .then(() => {
          return true;
        })
        .catch(() => {
          return false;
        });
    },
    patchAssessmentPlan(event, payload) {
      let id = "";
      if (this.itemGragging) {
        id = this.itemGragging.assessment_plan_pseudo_data_id;
      } else {
        id = this.selected_item.assessment_plan_pseudo_data_id;
      }

      return this.$httpService
        .patch(
          this.$config.api_url +
            this.$config.kanoon.assessment_plan_pseudo_data.replace(
              "{0}",
              this.$route.params.id
            ) +
            "/" +
            id,
          payload
        )
        .then((response) => {
          this.$notify.success(response.data.message);
          this.formModal = false;
          this.selected_item = {};
          return true;
        })
        .catch((error) => {
          this.$generateError(error);
          throw error;
        })
        .finally(() => {
          this.isLoading = false;
          if (event == "editForm") {
            this.getAssessment_plan_data();
          }
        });
    },
    async updateAssessmentPlan(event, payload) {
      try {
        this.isLoading = true;
        const id = this.itemGragging
          ? pathOr(null, ["assessment_plan_pseudo_data_id"], this.itemGragging)
          : pathOr(
              null,
              ["assessment_plan_pseudo_data_id"],
              this.selected_item
            );
        const url = generateApiUrl(
          ["kanoon", "assessment_plan_pseudo_data_id"],
          [this.id, id]
        );
        const response = await this.$httpService.put(url, payload);
        this.$notify.success(response.data.message);
        this.formModal = false;
        this.selected_item = {};
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.isLoading = false;
        if (event == "editForm") {
          this.getAssessment_plan_data();
        }
      }
    },
    handleBack() {
      if (this.isModal) {
        this.$emit("modal-end-up");
      } else {
        window.history.length > 1
          ? this.$router.go(-1)
          : this.$router.push("/");
      }
    },
    clear() {
      this.time = this.start_time;
      this.exercise_algorithm_selected = null;
      this.candidate_selected = [];
      this.assessor_selected = null;
      this.room_selected = null;
      this.exercise_id = null;
      this.selected_plan = null;
      this.selected_plan_id = null;
    },
    diff_minutes_save(dt2, dt1) {
      var diff = (dt2.getTime() - dt1.getTime()) / 1000;
      diff /= 60;
      return Math.abs(Math.round(diff));
    },
    async save() {
      this.errors = [];
      this.$v.$touch();

      try {
        this.isLoading = true;
        if (this.$v.$anyError) return;
        let dt1 = new Date(
          2020,
          1,
          15,
          this.start_time.split(":")[0],
          this.start_time.split(":")[1]
        );
        let dt2 = new Date(
          2020,
          1,
          15,
          this.time.split(":")[0],
          this.time.split(":")[1]
        );
        const url = generateApiUrl(
          ["kanoon", "assessment_plan_pseudo_data"],
          [this.id]
        );
        const payload = {
          day_number: pathOr(null, ["value"], this.day_selected),
          delay_from_start: this.diff_minutes_save(dt2, dt1),
          duration: this.runtime_duration,
          delay_for_send: this.delay_for_send,
        };
        if (this.is_enable == 1) {
          payload["resource"] = "exercise_algorithm";
          payload["resource_id"] = pathOr(
            null,
            ["value"],
            this.exercise_algorithm_selected
          );
        }
        if (this.is_enable == 2) {
          payload["resource"] = "exam_pack";
          payload["resource_id"] = pathOr(
            null,
            ["value"],
            this.exam_pack_selected
          );
        }
        if (this.candidate_selected) {
          payload["candidate_number"] = this.candidate_selected;
        }
        if (this.assessor_selected) {
          payload["assessor_number"] = this.assessor_selected;
        }
        if (this.room_selected) {
          payload["room_number"] = this.room_selected;
        }

        const response = await this.$httpService.post(url, payload);
        this.$notify.success(response.data.message);
        this.afterSave();
        this.$v.$reset();
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.isLoading = false;
      }
    },
    async getAssessment_plan() {
      try {
        this.assessment_planLoading = true;
        const url = generateApiUrl(["kanoon", "assessment_plan_id"], [this.id]);
        const response = await this.$httpService.get(url);
        const data = pathOr(null, ["data", "data"], response);
        this.currentTemplateId = pathOr(null, ["template", "id"], data);
        const templateCaption = pathOr(null, ["template", "caption"], data);
        const candidateCount = +pathOr(0, ["candidate_count"], data);
        const assessorCount = +pathOr(0, ["assessor_count"], data);
        const dayCount = +pathOr(0, ["day_count"], data);
        const roomCount = +pathOr(0, ["room_count"], data);
        const assessors = pathOr([], ["assessors"], data);
        const candidates = pathOr([], ["candidates"], data);

        this.end_time = pathOr(null, ["end_time"], data);
        this.start_time = pathOr(null, ["start_time"], data);
        this.duration = pathOr(null, ["time_step"], data);
        this.center_execute_type = pathOr(
          null,
          ["assessment_plan_type", "caption"],
          data
        );

        this.selectedZoom = this.selectedZoom || this.duration;
        if (this.selectedZoom && this.start_time && this.end_time) {
          this.createTimePlan(
            this.selectedZoom,
            this.start_time,
            this.end_time
          );
        }

        this.room_options = Array.from(
          {
            length: roomCount,
          },
          (v, k) => k + 1
        ).map((x) => {
          return {
            value: x,
            text: x,
          };
        });

        this.assessor_options = assessors.map(
          (x) => x.person_center_execute_code
        );
        this.candidate_options_checkbox = candidates.map(
          (x) => x.person_center_execute_code
        );

        this.candidate_number = Array.from(
          {
            length: candidateCount,
          },
          (v, k) => k + this.configCandidate
        ).map((x) => {
          return {
            value: x,
            text: x,
          };
        });

        this.day_options = Array.from(
          {
            length: dayCount,
          },
          (v, k) => k + 1
        ).map((x) => {
          return {
            value: x,
            text: x,
          };
        });

        this.day_selected = this.day_options[0];
        this.fields = [...this.candidate_number.map((c) => c.value.toString())];
        this.title = ` (${templateCaption} - ${candidateCount} ${this.$lang.candidate} ${assessorCount} ${this.$lang.assessor} ${roomCount} ${this.$lang.room})`;
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.assessment_planLoading = false;
      }
    },
    createTimePlan(timeStep, startTime, endTime) {
      this.time_step = timeStep;
      let start = new Date(
        2020,
        1,
        15,
        startTime.split(":")[0],
        startTime.split(":")[1]
      );

      let end = new Date(
        2020,
        1,
        15,
        endTime.split(":")[0],
        endTime.split(":")[1]
      );
      let outTimes = [];
      let diff = (start.getTime() - end.getTime()) / 1000;
      diff /= 60;
      let mins_step = Math.abs(Math.round(diff)) / timeStep;
      for (let index = 0; index < mins_step + 1; index++) {
        let createTime = new Date();
        let calculation = start.getTime() + timeStep * index * 60 * 1000;
        createTime.setTime(calculation);
        outTimes.push(
          `${(createTime.getHours() < 10 ? "0" : "") + createTime.getHours()}:${
            (createTime.getMinutes() < 10 ? "0" : "") + createTime.getMinutes()
          }`
        );
      }
      this.timeGrid = outTimes;

      // this.countGrid = [...Array(mins_step)];
      this.countGrid = outTimes.length - 1;
    },
    async getAssessment_plan_data() {
      try {
        this.assessment_plan_dataLoading = true;
        const url = generateApiUrl(
          ["kanoon", "assessment_plan_pseudo_data"],
          [this.id]
        );
        const response = await this.$httpService.get(url);
        const data = pathOr(null, ["data", "data"], response);
        const assessment_plan_data = pathOr([], ["plans"], data);
        this.readonly = pathOr(false, ["assessment_plan", "readonly"], data);
        const candidates = [];
        const candidates_number = [...this.candidate_options_checkbox];
        candidates_number.map((x) => {
          candidates.push({
            name: x,
            event: [],
          });
        });

        assessment_plan_data.map((x) => {
          const temp = candidates.find((a) => a.name == x.candidate_number);
          if (temp) {
            temp.event.push(x);
          }
        });
        this.items = candidates;
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.assessment_plan_dataLoading = false;
      }
    },
    async fetchData() {
      await this.getAssessment_plan();
      this.getAssessment_plan_data();
    },
    getRandomColor(id) {
      const Colors = [
        "#607d8b",
        "#ff5722",
        "#795548",
        "#9e9e9e",
        "#2f353a",
        "#81d4fa",
        "#006064",
        "#4caf50",
        "#8bc34a",
        "#cddc39",
        "#03a9f4",
        "#00bcd4",
        "#009688",
        "#673ab7",
        "#3f51b5",
        "#2196f3",
        "#f44336",
        "#e91e63",
        "#9c27b0",
        "#d50000",
      ];
      return Colors[id];
    },
    randomColor(item, idx) {
      if (!item) return;

      let index = item.assessment_plan_pseudo_data_id;
      if (this.viewMode == "exercise") index = item.type && item.type.id;
      if (this.viewMode == "assessor") index = item.assessor;
      if (this.viewMode == "room") index = item.room;
      if (!index) return;
      if (this.viewMode == "total") {
        return "#73818f";
      }
      if (!(index in this.colorsObject)) {
        this.colorsObject[index] = this.getRandomColor(index);
      }
      return this.colorsObject[index];
    },
    isEmptyPlan(item) {
      if (!item) return true;
      let index = item.assessment_plan_pseudo_data_id;
      if (this.viewMode == "exercise") index = item.type && item.type.id;
      if (this.viewMode == "assessor") index = item.assessor;
      if (this.viewMode == "room") index = item.room;
      if (!index) return true;
      return false;
    },
    selectPlan(item) {
      this.selected_item = item;
      if (this.isEmptyPlan(item)) return;
      this.formModal = true;
      this.selected_plan = item;
      this.selected_plan_id = item.assessment_plan_pseudo_data_id;
      this.mode = "edit";
      if (item.type && item.type.resource == "exercise_algorithm") {
        this.is_enable = 1;
        this.exercise_algorithm_selected = this.exercise_algorithm_options.find(
          (x) => x.value == (item.type && item.type.id)
        );
      } else {
        this.is_enable = 2;
        this.exam_pack_selected = this.exam_pack_options.find(
          (x) => x.value == (item.type && item.type.id)
        );
      }

      this.assessor_selected = item.assessor;
      this.room_selected = item.room;

      this.candidate_selected = [];
      this.candidate_single_selected = item.candidate_number;
      this.time = item.start;
      this.runtime_duration = item.duration;
      this.delay_for_send = item.delay_for_send;
    },
    clearAssessor() {
      this.assessor_selected = null;
    },
    clearRoom() {
      this.room_selected = null;
    },
    dragStart(event) {
      var format = "Text";
      const data = event.dataTransfer.setData("id", event.target.id);
    },
    dragging(event, item) {
      this.itemGragging = item;
    },
    dragEnter(event) {
      event.target.style.outline = "2px dotted #039be5";
    },
    dragLeave(event) {
      event.target.style.outline = "";
    },
    allowDrop(event) {
      event.preventDefault();
      if (event.target.getAttribute("draggable") == "true")
        event.dataTransfer.dropEffect = "none";
      // dropping is not allowed
      else event.dataTransfer.dropEffect = "all"; // drop it like it's hot
    },
    drop(event) {
      event.preventDefault();
      let data = event.dataTransfer.getData("id");
      this.dragged = document.getElementById(data);

      let id = event.target.id.split(".");
      let time = document.getElementById(`timeline-${id[1]}`).innerHTML;

      let candidate = id[0];
      this.dropEdit(time, candidate).then((x) => {
        if (x) {
          event.target.style.outline = "";
          event.target.appendChild(this.dragged);
          this.dragged.className += " dropped";
        } else {
          event.target.style.outline = "";
        }
      });
    },
    convertTime(time) {
      if (typeof time != "undefined" && time != null) {
        var res = time.split(":");
        return res[0] + "." + res[1];
      }
    },
    titleText(item) {
      let caption =
        item.type && item.type.caption
          ? `${this.$lang.exercise} :${item.type && item.type.caption}`
          : ``;
      let assessor = item.assessor
        ? ` - ${this.$lang.assessor}:${item.assessor}`
        : ``;
      let room = item.room ? ` - ${this.$lang.room}:${item.room}` : ``;
      let html = `${caption}${assessor}${room}`;

      return html;
    },
    diff_minutes(timeOne, timeTwo) {
      let time_two = new Date(
        2020,
        1,
        15,
        timeTwo.split(":")[0],
        timeTwo.split(":")[1]
      );
      let time_one = new Date(
        2020,
        1,
        15,
        timeOne.split(":")[0],
        timeOne.split(":")[1]
      );

      var diff = (time_one.getTime() - time_two.getTime()) / 1000;
      diff /= 60;
      return Math.abs(Math.round(diff));
    },
    styleEvent(timing) {
      const diffTop =
        this.diff_minutes(timing.start, this.start_time) / this.time_step;
      const top = diffTop * 26 + diffTop;
      const diffPosition =
        this.diff_minutes(timing.end, timing.start) / this.time_step;
      const position = diffPosition * 26 + diffPosition;
      return `top: ${top}px; height: ${position}px; width: 90%; right: 0px;background-color:${this.randomColor(
        timing
      )}`;
    },
    widthStyle() {
      let count_candidate = this.candidate_number.length;
      let percent = 100;
      let number = percent / count_candidate;
      return `width:${number}%`;
    },
    changeCandidateSelected() {
      if (this.mode == "edit") {
        this.candidate_selected = [
          this.candidate_selected[this.candidate_selected.length - 1],
        ];
      }
    },
  },
};
</script>

<style lang="css">
.inline-block {
  width: 200px;
  display: inline-block;
}

.text-link {
  color: white !important;
}

.skeduler-container {
  overflow-x: scroll;
}

.skeduler-headers {
  display: flex;
  padding-right: 50.9px;
  position: relative;
}

.skeduler-headers:before {
  content: "";
  width: 60px;
  position: absolute;
  left: 0;
}

.skeduler-headers > div {
  padding-top: 10px;
  border-bottom: 1px solid #0000004a;
  text-align: center;
}

.skeduler-cell {
  border-bottom: 1px solid #0000004a;
}

.skeduler-main {
  display: flex;
}

.skeduler-main-timeline {
  margin-top: 0;
  border-left: 1px solid #0000004a;
}

.timeline {
  position: relative;
  width: 50px;
  height: 27px;
  text-align: left;
  padding-left: 10px;
  color: #333333;
  top: -12px;
}

.skeduler-main-timeline div:nth-child(even)::after {
  position: absolute;
  content: "";
  width: 1px;
  height: 7px;
  background: #aaacae;
  -webkit-transform: rotate(90deg);
  transform: rotate(90deg);
  bottom: 12px;
  left: 2px;
}

.skeduler-main-body {
  display: flex;
}

.skeduler-main-timeline div,
.skeduler-main-body > div > div.skeduler-cell {
  background-color: transparent;
}

.skeduler-main-body > div > div.skeduler-cell {
  width: 200px;
  height: 27px;
  border-left: 1px solid #aaacae;
}

.skeduler-main-body > div > .skeduler-task-placeholder {
  height: 0;
  position: relative;
}

.skeduler-main-body > div > .skeduler-task-placeholder > div {
  position: absolute;
  overflow: hidden;
  background-color: #039be5;
  border-right: 3px solid;
  padding: 10px;
  box-sizing: border-box;
  margin-top: 2px;
  cursor: pointer;
  color: #ffffff;
  min-width: 0;
  min-height: 30px;
  transition: all 0.4s;
  border-radius: 4px;
}

.showTime {
  width: 100%;
  height: 4px;
  top: 300px;
  background: red;
  position: absolute;
  left: 0;
  cursor: pointer;
  -webkit-transition: all 0.4s;
  transition: all 0.4s;
}

.circleShowTime {
  width: 10px;
  height: 10px;
  top: 297px;
  background: red;
  border-radius: 50%;
  background: red;
  position: absolute;
  right: 0;
}

.cursor-pointer {
  cursor: pointer;
}

.dropped {
  overflow: hidden;
  position: sticky;
  border-right: 3px solid #039be5;
  margin-top: 1px;
  cursor: pointer;
  color: #ffffff;
  min-width: 0;
  border-radius: 4px;
}

.white-space {
  white-space: pre;
}
</style>
